// @flow
import React from 'react';
import { GridToolbarContainer } from "@mui/x-data-grid-premium";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import AddPlusIcon from "../../../../assets/images/icons/buttons/addPlusIcon";
import { EDITABLE_MUI_GRID } from "../../../../locales/components/namespaces";
import { normalizeGreek } from "../../../../helpers/normalizeGreek";

type Props = {
	addNewRow: Function
};

const EditGridToolBar = (props: Props) => {
	const { handleAddNewRow, disableAddingNewRow } = props
	const { t } = useTranslation(EDITABLE_MUI_GRID)
	return (
		<GridToolbarContainer>
			<Button
				disabled={disableAddingNewRow}
				color={"highlight"}
				size={"small"}
				startIcon={<AddPlusIcon/>}
				onClick={handleAddNewRow}
				sx={{textTransform: 'uppercase'}}
			>
				{normalizeGreek(t('Add'))}
			</Button>
		</GridToolbarContainer>
	);
};

export default EditGridToolBar